import { msg } from 'gt-react';
import { ArrowCounterClockwiseIcon } from '@phosphor-icons/react';
import { Action, Subject } from '@erp/authz';
import { ProductModule } from '@erp/shared-types';
import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';
import { Route as pathlessAuthenticatedRoute, requireModules } from '../route';

const FamousEDIPage = lazyRouteComponent(() => import('./FamousEDIPage'));

export const Route = createRoute({
  getParentRoute: () => pathlessAuthenticatedRoute,
  path: '/famous-edi',
  staticData: {
    app: {
      nav: {
        label: msg('Famous EDI (Invoices)', {
          context: 'sidebar nav label, Sales section',
        }),
        icon: <ArrowCounterClockwiseIcon className="h-4 w-4" weight="fill" />,
        group: 'Sales',
        order: 50,
      },
      access: {
        modulesAllOf: [
          ProductModule.ORDERFUL_EDI,
          ProductModule.FAMOUS_INTEGRATION,
        ],
        permissionsAnyOf: [
          { action: Action.Read, subject: Subject.SalesOrder },
        ],
      },
    },
  },
  component: FamousEDIPage,
  loader: () => ({
    crumb: msg('Famous EDI', { context: 'page breadcrumb' }),
  }),
  validateSearch: z.object({
    invoiceId: z.uuid().optional(),
    // Filter state lives in the URL so links are shareable and reloads
    // preserve what the user was looking at. YYYY-MM-DD for dates.
    orderId: z.string().optional(),
    purchaseOrderNumber: z.string().optional(),
    customerId: z.uuid().optional(),
    ediInvoiceType: z.enum(['810', '880']).optional(),
    ediSendStatus: z.enum(['sent', 'error', 'not_sent']).optional(),
    importedFrom: z.string().optional(),
    importedTo: z.string().optional(),
    page: z.coerce.number().int().min(1).optional(),
    pageSize: z.coerce.number().int().min(1).max(100).optional(),
  }),
  beforeLoad: ({ context }) => {
    requireModules({
      context,
      allOf: [ProductModule.ORDERFUL_EDI, ProductModule.FAMOUS_INTEGRATION],
    });
  },
});
